import { render, staticRenderFns } from "./DashboardToggle.vue?vue&type=template&id=e8a3e444&scoped=true&"
import script from "./DashboardToggle.vue?vue&type=script&lang=js&"
export * from "./DashboardToggle.vue?vue&type=script&lang=js&"
import style0 from "./DashboardToggle.vue?vue&type=style&index=0&id=e8a3e444&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a3e444",
  null
  
)

export default component.exports